export const filterByUnique = (value: any, index: number, self: any[]) => {
	return self.indexOf(value) === index;
};
